import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useNavigate } from 'react-router-dom'
import { Footer } from '@campgladiator/cgui-core.organisms.footer'
import { Header } from '@campgladiator/cgui-core.organisms.header'
import { authLogout } from '../../../redux/features/authActions'
import { config } from '../../utility'

const ProtectedRoute = () => {
  const { isLoggedIn, user, redirectPath } = useSelector(
    (state) => state.authReducer,
  )
  const { hasPreviousChallenges } = useSelector(
    (state) => state.challengeReducer,
  )
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleOnLogout = useCallback(() => {
    dispatch(authLogout())
    navigate(redirectPath)
  }, [dispatch, navigate, redirectPath])

  const userButtonPropsWithAvatar = {
    items: [],
    avatar: {
      alt: `${user?.firstName} ${user?.lastName}`,
      src: user?.imageURL ?? config.REACT_APP_PLACEHOLDER_IMG_URL,
    },
  }

  useEffect(() => {
    if (!isLoggedIn || !hasPreviousChallenges) {
      handleOnLogout()
    }
  }, [isLoggedIn, hasPreviousChallenges, handleOnLogout])

  return isLoggedIn && hasPreviousChallenges ? (
    <>
      <Header
        isLoggedIn={isLoggedIn}
        userButton={userButtonPropsWithAvatar}
        onLogoutClick={handleOnLogout}
      />
      <div className="wrapper">
        <main className="container">
          <Outlet />
        </main>
      </div>
      <Footer />
    </>
  ) : null
}

export default ProtectedRoute
